export function onlyDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export function formatCpf(value: string): string {
  const digits = onlyDigits(value).slice(0, 11);
  const groups = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9)].filter(Boolean);
  const checkDigits = digits.slice(9, 11);

  return checkDigits ? `${groups.join('.')}-${checkDigits}` : groups.join('.');
}

export function formatPhone(value: string): string {
  const digits = onlyDigits(value).slice(0, 11);

  if (digits.length <= 2) {
    return digits ? `(${digits}` : '';
  }

  const areaCode = digits.slice(0, 2);
  const rest = digits.slice(2);

  if (rest.length <= 4) {
    return `(${areaCode}) ${rest}`;
  }

  const isMobile = digits.length > 10;
  const localNumberLength = isMobile ? 5 : 4;
  const localNumber = rest.slice(0, localNumberLength);
  const lineNumber = rest.slice(localNumberLength);

  return lineNumber ? `(${areaCode}) ${localNumber}-${lineNumber}` : `(${areaCode}) ${localNumber}`;
}

/** Valida o dígito verificador do CPF (algoritmo módulo 11). */
export function isValidCpf(value: string): boolean {
  const digits = onlyDigits(value);

  if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) {
    return false;
  }

  const calculateCheckDigit = (length: number): number => {
    const sum = digits
      .slice(0, length)
      .split('')
      .reduce((total, digit, index) => total + Number(digit) * (length + 1 - index), 0);
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };

  return (
    calculateCheckDigit(9) === Number(digits[9]) && calculateCheckDigit(10) === Number(digits[10])
  );
}
